import moment from 'moment';

export function cachePromise(promiseGenerator, duration) {
  const cache = {};
  const pending = {};

  return (...args) => {
    const id = args.map(x => moment.isMoment(x) ? moment(x).startOf('day') : x).join('|');

    if (cache.hasOwnProperty(id)) {
      return Promise.resolve(cache[id]);
    }

    if (pending.hasOwnProperty(id)) {
      return pending[id];
    }

    pending[id] = promiseGenerator(...args.map(x => moment.isMoment(x) ? x.format() : x))
      .then(results => {
        cache[id] = results;
        delete pending[id];

        setTimeout(() => delete cache[id], duration);

        return results;
      });

    return pending[id];
  };
}
